module.exports = __webpack_public_path__ + "static/media/mail.3224c2bb.png";